<!--
 * @Descripttion: 登录页面组件
 * @Author: congz
 * @Date: 2020-06-11 11:08:34
 * @LastEditors: congz
 * @LastEditTime: 2020-08-09 20:05:20
--> 

<template>
  <div class="vaild-email">
    <div class="vaild-email-content">
      <p>{{message}}</p>
    </div>
  </div>
</template>
<script>
import * as userAPI from '@/api/users'
import { mapActions } from 'vuex'
export default {
  name: 'VaildEmail',
  data() {
    return {
      token: '',
      message: 'Binding/unbinding email, please wait...'
    }
  },
  methods: {
    ...mapActions(['setUser']),
    vaild() {
      userAPI
        .vaildEmail(this.token)
        .then(res => {
          if (res.status === 200) {
            let user = JSON.stringify(res.data)
            localStorage.setItem('user', user)
            this.setUser(res.data)
            this.message = 'Email binding/unbinding successful, redirect to page...'
            this.$router.push({
              name: 'Center'
            })
            this.notifySucceed('Binding/unbinding successful')
          } else if (res.status === 201) {
            // 清空本地登录信息
            localStorage.removeItem('user')
            localStorage.removeItem('token')
            // 清空vuex登录信息
            this.setUser('')
            this.$router.push({
              name: 'Login'
            })
            this.notifySucceed('Password has been changed, please log in again')
          } else if (res.status === 20001) {
            this.notifyError('This link is no longer valid, please rebind/unbind it', res.msg)
            this.$router.push({
              name: 'Center'
            })
          } else {
            this.notifyError('Email binding/unbinding failed', res.msg)
          }
        })
        .catch(error => {
          this.notifyError('Email binding/unbinding failed', error)
        })
    }
  },
  created() {
    this.token = this.$route.params.token
    this.vaild()
  },
  components: {}
}
</script>

<style scoped>
.vaild-email {
  height: 700px;
  display: flex;
  align-items: center;
}
.vaild-email .vaild-email-content {
  width: 500px;
  margin: 0 auto;
  text-align: center;
}
</style>
